<template>
    <Layout>
        <div class="card">
            <div class="card-body">
                <PageHeader :title="title" :items="items" />
                <div class="form-row">
                    <div class="col-md-8">
                        <button class="btn btn-info m-1" v-on:click="nuevo">Nuevo</button>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Filtro de escuela</label>
                        <v-select
                                :options="carreras_profesionales"
                                label="carrera"
                                :reduce="carrera=>carrera.codigo"
                                v-model="filtro.codigo_carrera"
                                @input="loadItems()"
                        />
                    </div>
                </div>



                <vue-good-table
                        ref="tblEncuestas"
                        mode="remote"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-search="onSearch"
                        :totalRows="totalRecords"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                            enabled: true
                         }"
                        :rows="rows"
                        :columns="columns"
                        :globalSearch="true"
                        @on-row-dblclick="onRowDoubleClick"
                        styleClass="vgt-table smalltable fixfont"
                        :search-options="{
                            enabled: true,
                            //trigger: 'enter',
                            skipDiacritics: true,
                            placeholder: 'buscarEnTabla'
                        }"
                        :select-options="{
                            selectOnCheckboxOnly: true,
                            enabled: true,
                            selectionText: 'Filas seleccionadas',
                            clearSelectionText: 'Borrar'
                          }"
                        :sort-options="{
                          enabled: false,
                          }"
                >
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'nombres'">
                          <a href="#" v-on:click="verEstudiante(props.row)">{{props.row.nombres}}</a>
                        </span>
                        <span v-else-if="props.column.field == 'acciones'">
                            <button class="btn btn-info btn-icon btn-sm mr-1" v-on:click="ver(props.row)" ><i class="fa fa-eye"></i></button>
                            <button class="btn btn-primary btn-icon btn-sm mr-1" v-on:click="derivaciones(props.row.id)">Derivaciones</button>
                            <button class="btn btn-warning btn-icon btn-sm" v-on:click="modificar(props.row.id)"><i class="fa fa-edit"></i></button>
                        </span>
                        <span v-else class="fixfont">
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>

                    <div slot="table-actions">

                    </div>
                </vue-good-table>

                <b-modal
                        id="modalModel"
                        scrollable
                        title="Nuevo tramite físico"
                        title-class="font-18"
                        size="xl"
                        no-close-on-esc
                        centered
                        hide-footer
                >

                    <form class="needs-validation" @submit.prevent="formSubmit">
                        <b-overlay :show="isLoading" rounded="sm">
                        <div class="card">
                            <div class="card-body">
                                <div class="form-row big-font">
                                    <div class="form-group col-md-4">
                                        <label>Oficina</label>
                                        <v-select :options="user.oficinas"
                                                  label="descripcion"
                                                  v-model="oficina_seleccionada"
                                        />
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label>Tipo documento</label>
                                        <v-select :options="documentos_tipos"
                                                  label="descripcion"
                                                  v-model="documento_seleccionado"
                                        />
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>Número documento</label>
                                        <input class="form-control"
                                               v-model="model.numero_documento"
                                               :class="{ 'is-invalid': submitted && $v.model.numero_documento.$error }"
                                               v-tooltip="'Form id de google'"
                                        />
                                        <div v-if="submitted && $v.model.numero_documento.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.numero_documento.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-5">
                                        <label>Remite</label>
                                        <input class="form-control"
                                               v-model="model.remite"
                                               :class="{ 'is-invalid': submitted && $v.model.remite.$error }"
                                               v-tooltip="'Form id de google'"
                                        />
                                        <div v-if="submitted && $v.model.remite.$error" class="invalid-feedback">
                                            <span v-if="!$v.model.remite.required">Este valor es requerido.</span>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-7">
                                        <label>Observaciones</label>
                                        <input class="form-control"
                                               v-model="model.observaciones"
                                               v-tooltip="'Ingrese las observaciones'"
                                        />

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <b-button block variant="info"  type="submit" >
                                            Guardar
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </b-overlay>
                    </form>
                </b-modal>

                <b-modal
                        id="modalDerivaciones"
                        scrollable
                        title="Tramite fisico Derivaciones"
                        title-class="font-18"
                        size="lg"
                        no-close-on-esc
                        centered
                        hide-footer
                >
                    <b-overlay :show="isLoading" rounded="sm">
                        <div class="card" >
                            <div class="card-body">
                                <div class="form-row big-font">
                                    <div class="col-md-6">
                                        <dl>
                                            <dt>Oficina</dt>
                                            <dd>{{model.oficina}}</dd>

                                            <dt>Tipo documento</dt>
                                            <dd>{{model.tipo_documento}}</dd>

                                            <dt>Nº Documento</dt>
                                            <dd>{{model.numero_documento}}</dd>

                                        </dl>
                                    </div>
                                    <div class="col-md-6">
                                        <dl>
                                            <dt>Remite</dt>
                                            <dd>{{model.remite}}</dd>

                                            <dt>Fecha</dt>
                                            <dd>{{model.fecha}}</dd>
                                        </dl>
                                    </div>
                                </div>
                                <div class="form-row big-font">
                                    <div class="form-group col-md-3">
                                        <label>Tipo</label>
                                        <select class="form-control" v-model="derivacion_actual.tipo">
                                            <option value="SALIDA">SALIDA</option>
                                            <option value="ENTRADA">ENTRADA</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label>Oficina</label>
                                        <input class="form-control" v-model="derivacion_actual.oficina" type="text"/>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>Encargado</label>
                                        <input class="form-control" v-model="derivacion_actual.encargado" type="text"/>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <button type="button" class="btn btn-primary mt-4" v-on:click="derivar">Derivar</button>
                                    </div>
                                </div>
                                <div class="form-row big-font">
                                    <table class="table table-bordered">
                                        <thead>
                                            <th>Tipo</th>
                                            <th>Oficina</th>
                                            <th>Encargado</th>
                                            <th>Fecha</th>
                                            <th>Opciones</th>
                                        </thead>
                                        <tbody v-for="(item,index) in model.derivaciones" v-bind:key="index">
                                        <tr>
                                            <td >{{item.tipo}}</td>
                                            <td >{{item.oficina}}</td>
                                            <td >{{item.encargado}}</td>
                                            <td>{{item.fecha}}</td>
                                            <td></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </b-overlay>

                </b-modal>


            </div>
        </div>
    </Layout>
</template>

<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import PageHeader from "@/components/page-header";
    import { required} from "vuelidate/lib/validators";
    import constantes from "../../../config/Constantes";


    /**
     * Dashboard Component
     */
    export default {
        page: {
            title: "Recepción de expedientes",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            Layout,
            PageHeader

       },
        data() {
            return {
                filtro:{

                },

                title: "Tramites en físico",
                items: [
                    {
                        text: "Tramites en físico",
                        href: "/"
                    },
                    {
                        text: "Tramites",
                        active: true
                    }
                ],

                isLoading: false,
                columns: [
                    {
                        label: "ID",
                        field:"id"
                    },
                    {
                        label: "Documento",
                        field:"documento_tipo"
                    },
                    {
                        label: "Nº documento",
                        field:"numero_documento"
                    },
                    {
                        label: "Remite",
                        field:"remite"
                    },
                    {
                        label: "Fecha",
                        field:"fecha"
                    },

                    {
                        label: "Acciones",
                        field: "acciones",
                        width: '200px'
                    }

                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: "",
                        type: ""
                    },
                    page: 1,
                    perPage: 10
                },
                server: process.env.VUE_APP_BACKEND,
                /////////////
                model:{

                },
                submitted: false,
                isLoadingForm:false,
                isLoadingName:false,
                carreras_profesionales:constantes.carreras_profesionales,
                carrera:null,
                estudiante:{},
                deshabilitarNombre:true,
                encuesta:null,
                documentos_tipos:[],
                documento_seleccionado:null,
                oficina_seleccionada:null,
                derivacion_actual:{}
                ////////////////
            };
        },

        methods: {

            derivar(){
                this.isLoading=true;
                this.derivacion_actual.tramite_fisico_id=this.model.id;
                this.axios.post(
                    process.env.VUE_APP_BACKEND + "/api/tramites-fisico/derivar",{
                        derivacion:this.derivacion_actual
                    }
                )
                    .then((response)=>{
                        this.model=response.data.model;
                        //this.$bvModal.show("modalDerivaciones");
                    })

                    .finally(()=>{
                        this.isLoading=false;
                    })
            },
            derivaciones(id){
                this.isLoading=true;
                this.model={};
                this.axios.get(
                    process.env.VUE_APP_BACKEND + "/api/tramites-fisico/"+id
                )
                    .then((response)=>{
                        this.model=response.data;
                        this.$bvModal.show("modalDerivaciones");
                    })

                    .finally(()=>{
                        this.isLoading=false;
                    })
            },
            ver(row){
                this.isLoading=true;
                this.model.id=row.id;
                this.axios.get(
                    process.env.VUE_APP_BACKEND + "/api/encuestas/google-data/"+row.id
                )
                    .then((response)=>{
                        this.encuesta=response.data.encuesta;
                        this.archivo_encuesta=response.data.archivo;
                        //this.estudiante=response.data;
                        this.$bvModal.show("modalEncuesta");
                    })

                    .finally(()=>{
                        this.isLoading=false;
                    })
            },
            modificar(id){
                this.isLoading=true;
                this.nuevo_modelo=false;
                this.modificar_modelo=true;
                this.axios.get(process.env.VUE_APP_BACKEND + "/api/tramites-fisico/"+id)
                    .then((response)=>{
                        this.model=response.data;
                        //documento_seleccionado:null,
                        //    oficina_seleccionada:null
                        this.documento_seleccionado=
                            this.$matchElement(this.documentos_tipos,'id',this.model.documento_tipo_id);
                        this.oficina_seleccionada=
                            this.$matchElement(this.user.oficinas,'id',this.model.oficina_id);
                        this.$bvModal.show("modalModel");
                    })
                    .finally(()=>{
                        this.isLoading=false;
                    })

            },
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault();
                // Trigger submit handler
                this.formSubmit()
            },
            nuevo(){
                this.submitted=false;
                this.nuevo_modelo=true;
                this.modificar_modelo=false;

                this.model={

                };
                this.$bvModal.show("modalModel");

            },
            updateText(texto){
                console.log(texto);
                this.razonRechazo=texto;
            },

            onSearch: function(params) {
                this.updateParams({ page: params.page });
                this.updateParams({ searchTerm: params.searchTerm });
                this.loadItems();
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({ perPage: params.currentPerPage });
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [
                        {
                            type: params.sortType,
                            field: this.columns[params.columnIndex].field
                        }
                    ]
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            // load items is what brings back the rows from server
            loadItems() {
                this.isLoading = true;
                this.serverParams.codigo_carrera=this.filtro.codigo_carrera;
                this.axios
                    .get(process.env.VUE_APP_BACKEND + "/api/tramites-fisico/tabla", {
                        params: this.serverParams
                    })
                    .then(response => {
                        //console.log(response.data.data);
                        this.totalRecords = response.data.total_records;
                        this.rows = response.data.data;
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                        //console.log(error);
                    });
            },
            /* eslint-disable */
            onRowDoubleClick(params) {
                //this.$bvModal.show("modalExpediente");/
                //this.mostrarModal(params.row.id);
            },
            formSubmit(e) {
                this.submitted = true;
                this.$v.$touch();
                if(this.$v.$error==false){
                    this.guardar();
                }

            },

            /* eslint-enable */
            guardar(){
                this.isLoading = true;
                this.model.documento_tipo_id=this.documento_seleccionado.id;
                this.model.oficina_id=this.oficina_seleccionada.id;

                const url = this.nuevo_modelo
                    ? `${process.env.VUE_APP_BACKEND}/api/tramites-fisico`
                    : `${process.env.VUE_APP_BACKEND}/api/tramites-fisico/${this.model.id}`;
                this.axios
                    .request({
                        url,
                        method: this.nuevo_modelo ? 'post' : 'put',
                        data: { model: this.model },
                    })
                    .then((response) => {
                        if (response.data.success) {
                            this.$bvModal.hide("modalModel");
                            this.loadItems();
                        }
                    })
                    .catch((err) => {
                        this.$swal('error', err.mensaje, 'warning');
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });

            }



        },
        mounted() {
            this.loadItems();
            this.user=JSON.parse(localStorage.getItem('user'));
            this.axios.get(process.env.VUE_APP_BACKEND+'/api/documento-tipo')
                .then((response)=>{
                    this.documentos_tipos=response.data;
                });
        },
        validations: {
            model: {
                numero_documento:{required},
                remite: {required}

            }

        },
    };
</script>

<style>
    .fixfont {
        font-size: 12px !important;
        color: #000000 !important;
    }
</style>
